import {
  buildOWPricedCalendarRequest,
  buildRTPricedCalendarRequest,
  shouldRequestMonthFromApi,
} from '../helper/helper'

import { handleRequest } from './helpers/handleRequest.js'
import { shouldDisplayOW } from './helpers/shouldDisplayOW.js'

const ONE_WAY = 'one-way'
const ROUND_TRIP = 'round-trip'

export function getPricingData(
  displayMonths,
  flightDetails,
  pricePromise,
  variantName,
  executedMonths,
  departDate,
  getGraphURL,
  apolloClientInfo,
) {
  if (shouldRequestMonthFromApi(displayMonths, executedMonths)) {
    let retailRequest = {}

    if ((flightDetails && flightDetails.tripType === ONE_WAY) || shouldDisplayOW(departDate, flightDetails)) {
      retailRequest = buildOWPricedCalendarRequest(flightDetails, displayMonths)
    } else if (flightDetails && flightDetails.tripType === ROUND_TRIP) {
      retailRequest = buildRTPricedCalendarRequest(flightDetails, displayMonths, departDate)
    } else {
      return Promise.resolve(null)
    }

    return handleRequest(retailRequest, variantName, pricePromise, getGraphURL, apolloClientInfo)
  }
  return Promise.resolve(null)
}
